import React, { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/audit-log?limit=300").then(({ data }) => setRows(data));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-4" data-testid="audit-page">
      <h1 className="text-2xl font-medium tracking-tight">Audit Log</h1>
      <p className="text-xs text-slate-500 uppercase tracking-[0.15em]">
        Append-only record of every user &amp; system action
      </p>

      <div className="surface rounded-sm overflow-x-auto">
        <table className="dt">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Before</th>
              <th>After</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid="audit-row">
                <td className="font-mono text-slate-400">{fmtDateTime(r.timestamp)}</td>
                <td className="font-mono text-slate-300">{r.actor}</td>
                <td className="text-[11px] uppercase tracking-[0.1em] text-blue-300">{r.action}</td>
                <td className="text-[11px] text-slate-400 max-w-xs truncate font-mono" title={JSON.stringify(r.before)}>{r.before ? JSON.stringify(r.before) : "—"}</td>
                <td className="text-[11px] text-slate-400 max-w-xs truncate font-mono" title={JSON.stringify(r.after)}>{r.after ? JSON.stringify(r.after) : "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan="5" className="text-center text-slate-500 py-8">No audit records yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
